import React from "react";
import PageHeader from "../components/PageHeader";
import { gangajiBabuImg } from "../assets/assets.js";
import "../css/commontemplate.css";

const Gangaji = () => {
  return (
    <>
      <PageHeader
        title="श्रीगंगाजीबापूमहाराज "
        path="/gangaji"
        name=" Gangajibapu maharaj"
      />
      {/* <Initiatives /> */}
      <div className="comman-template-section">
        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={gangajiBabuImg.g_img01}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              <div className="comman-template-info-container-shlok">
                मराठा लाड वंशसस्थं पिप्पल ग्राम पावकम्। <br />
                गंगाजीबापू नामानं वंदे गोदात्मजं शिवम्॥
              </div>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;संतवर्य
                श्रीगंगाजीबापूमहाराज यांचा जन्म मराठवाड्यातील परभणी जिल्ह्यात
                पूर्णा तालुक्यातील पिंपळगाव लाड या गावी मराठा लाडवंशामध्ये झाला.
                नाथपंथातील महायोगी श्रीअमृत गिरीमहाराज यांच्याकडून 
                गंगाजीबापूंना कालांतराने महान योग दीक्षा प्राप्त झाली. योगाच्या
                साधनेने गंगाजीबापू हे दिसायला अत्यंत साधे परंतु महान सिध्दयोगी
                होते. बापूंच्या चरित्रात असा उल्लेख सापडतो की गतजन्मी महान
                ज्ञानी असून देखील केवळ गरिबीमुळे गो सेवा घडू शकले नाही म्हणून
                श्रीबापूंनी हा जन्म जणू परमेश्वराला गो सेवेसाठी मागूनच घेतला
                होता. बापूंनी गरीब परंतू शेतकऱ्याच्या कुटुंबामध्ये जन्म घेवून
                आजन्म गोपाल कृष्णांप्रमाणेच गाईंची सेवा केली. बापूंनी शेती देखील
                केली परंतु शेतीतील जाणे पाखरांनी खावेत व उरलेला चारा गाईंना
                चारावा अशी बापूंची शेतीची पध्दत होती.
              </p>
              <p>
                {" "}
                &nbsp;&nbsp;एवढेच नव्हे तर जवळपास एक किलोमीटर लांब अंतरापर्यंत
                गंगेवरून पाणी आणून ते थंड रांजणात भरावे व ते गाईंना पाजावे. एक
                वेळ आपण उपाशी राहावे पण गाईंना पोटभर चारावे अशी बापूंची महान
                गोसेवा होती. बापूंनी आजन्म गोसेवा व योगसाधना केली. आपल्या महान
                योग शक्तीच्या बळावर गाईंचे रक्षण करण्यासाठी गंगाजीबापू पिंपळगावी
                लिंबाच्या झाडाखाली सिंहरूप धारण करून रात्रभर गाईंचे संरक्षण
                करण्याच्या आख्यायिका देखील अनेक ठिकाणी पाहण्यास मिळतात.
              </p>
              <p>
                &nbsp;&nbsp;आपली ही दिव्य योगशक्ती योग्य शिष्याला समर्पित करावी
                या हेतूने बापू उत्तम शिष्याच्या शोधात होते त्यावेळी त्यांचं लक्ष
                श्रीदाजीमहाराजांवर गेलं श्रीदाजीमहाराजांना लहानपणापासून
                बापूंनी पारखलं आणि आपला अंतकाळ जवळ आल्याचं ओळखून आपली दिव्य
                योगशक्ती शक्तिपात दिक्षेच्या माध्यमातून श्रीदाजीमहाराजांना
                त्यांनी हस्तांतरित केली.
              </p>
              <p>
                &nbsp;&nbsp;संतवर्य श्रीगंगाजीबापूंच्या अनेक चमत्कृर्तींचे
                वर्णन श्रीराजेगुरु दर्शन या ग्रंथात तसेच श्रीसंतकवी 
                श्रीदासगणूमहाराज लिखित संत चरित्र अमृत या ग्रंथात देखील पाहण्यास
                मिळते. आजही श्रीगंगाजीबापू देवस्थान या ठिकाणी अनेक भक्तगण
                महाराजांच्या सेवेत समाधी दर्शनासाठी व सेवेसाठी जाऊन अनेक
                प्रकारच्या त्रिविध तापातून मुक्त झाल्याचे पाहायला मिळते.
              </p>
            </div>
          </div>
          {/* second one  */}

          <div className="comman-template-sub-section"></div>
        </div>
      </div>

    </>
  );
};

export default Gangaji;
